'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

let _ = t => t,
    _t,
    _t2,
    _t3;

import PropTypes from 'prop-types';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import H7 from 'UIComponents/elements/headings/H7';
import { BATTLESHIP } from 'HubStyleTokens/colors';
import UIIcon from 'UIComponents/icon/UIIcon';
import breakpoint from 'pricing-pages-unified-ui/utils/responsiveBreakpoints';
import CodeSplitEnvWrapper from 'pricing-pages-unified-ui/components/CodeSplitEnvWrapper';
import classNames from '../../utils/classNames';
const PhoneSupportWrapper = styled.div.withConfig({
  displayName: "PhoneSupport__PhoneSupportWrapper",
  componentId: "sc-1hu55hj-0"
})(["", ""], breakpoint.tablet(_t || (_t = _`
    padding: 0 20px;
  `)));
const PhoneSupportContainer = styled.div.withConfig({
  displayName: "PhoneSupport__PhoneSupportContainer",
  componentId: "sc-1hu55hj-1"
})(["border:", ";border-radius:200px;margin:0 auto;text-align:center;padding:15px 44px 0;"], ({
  border
}) => border ? `1px ${BATTLESHIP} solid` : 'none');
const PhoneNumberContainer = styled.div.withConfig({
  displayName: "PhoneSupport__PhoneNumberContainer",
  componentId: "sc-1hu55hj-2"
})(["display:inline-flex;align-items:flex-start;", ""], breakpoint.tablet(_t2 || (_t2 = _`
    display: block;
    white-space: nowrap;
  `)));
const StyledIcon = styled(UIIcon).withConfig({
  displayName: "PhoneSupport__StyledIcon",
  componentId: "sc-1hu55hj-3"
})(["margin-right:10px;font-size:15px;", ""], breakpoint.tablet(_t3 || (_t3 = _`
    font-size: 24px;
  `)));
const StyledHeader = styled(H7).withConfig({
  displayName: "PhoneSupport__StyledHeader",
  componentId: "sc-1hu55hj-4"
})(["line-height:1.8;margin-bottom:0.75em;text-align:center;font-size:1.15em;.phone-support-header{display:block;}"]);

function PhoneSupport({
  phoneSourceId,
  border,
  showCopy,
  screen,
  className
}) {
  return /*#__PURE__*/_jsxs(PhoneSupportWrapper, {
    className: classNames(className),
    children: [showCopy && /*#__PURE__*/_jsxs(StyledHeader, {
      "data-selenium-id": "phone-support-header",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricingPage.pages.crm.notSure",
        className: "phone-support-header"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricingPage.pages.crm.notSureSubHeader",
        className: "phone-support-subheader"
      })]
    }), /*#__PURE__*/_jsx(PhoneSupportContainer, {
      className: "phone-support-container",
      border: border,
      children: /*#__PURE__*/_jsxs(PhoneNumberContainer, {
        children: [/*#__PURE__*/_jsx(StyledIcon, {
          name: "calling"
        }), /*#__PURE__*/_jsx(CodeSplitEnvWrapper, {
          authedComponentLoader: () => import(
          /* webpackChunkName: "authed-chunk" */
          'pricing-pages-unified-ui/components/common/phone-numbers/AuthedPhoneNumber'),
          publicComponentLoader: () => import(
          /* webpackChunkName: "public-chunk" */
          'pricing-pages-unified-ui/components/common/phone-numbers/PublicPhoneNumber'),
          authedComponentProps: {
            phoneSourceId,
            screen
          },
          publicComponentProps: {
            phoneSourceId,
            screen
          }
        })]
      })
    })]
  });
}

PhoneSupport.propTypes = {
  phoneSourceId: PropTypes.string.isRequired,
  border: PropTypes.bool.isRequired,
  showCopy: PropTypes.bool.isRequired,
  screen: PropTypes.string.isRequired,
  className: PropTypes.string
};
PhoneSupport.defaultProps = {
  border: true,
  showCopy: true
};
export default PhoneSupport;